/**
 * The cost a hint stands for (batch 8 T11): exact, in 0.0001 cent, and only when the hint holds a usable
 * value. A hint is a suggestion read from the catalog, the last receipt or the preferred supplier; the
 * server never applies one, and the user adopting it still has to confirm.
 */
import type { OpeningLayer } from '@/hooks/useInventoryCosting';
import { cents4FromWholeCents, parseCents4Text } from './costMoney';

export type HintSource = 'last_receipt' | 'catalog_cost' | 'supplier_price';

/** The cost a hint stands for, exact, in 0.0001 cent; `null` when the hint holds no usable value. */
export function hintCents4(row: OpeningLayer, source: HintSource): bigint | null {
  const hints = row.hints;
  if (!hints) return null;
  if (source === 'last_receipt') return hints.lastReceipt ? parseCents4Text(hints.lastReceipt.unitCostCents4) : null;
  if (source === 'catalog_cost') {
    return hints.catalogCost.status === 'recorded' && hints.catalogCost.unitCostCents !== null
      ? cents4FromWholeCents(hints.catalogCost.unitCostCents)
      : null;
  }
  return hints.preferredSupplier ? cents4FromWholeCents(hints.preferredSupplier.unitCostCents) : null;
}
